import type { SignalProviderVerifiedStatus } from '@brushfire/types'

export const VERIFIED_STATUS_PILL_STYLES: Record<
  SignalProviderVerifiedStatus,
  { bg: string; border: string; color: string; label: string }
> = {
  verified: { bg: '#d1fae5', border: '#10b981', color: '#065f46', label: 'Verified' },
  unverified: { bg: '#fef3c7', border: '#f59e0b', color: '#92400e', label: 'Unverified' },
  failed: { bg: '#fee2e2', border: '#ef4444', color: '#991b1b', label: 'Failed' },
}

export function formatVerifiedStatusLabel(status: SignalProviderVerifiedStatus): string {
  return VERIFIED_STATUS_PILL_STYLES[status].label
}
